import React, { FC, useContext } from 'react';
import styled from 'styled-components';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { CmsContext } from 'logic/context/cms';
import { VideoPlayer } from 'components/video/VideoPlayer';
import { Card } from 'antd';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { Text } from 'components/text/Text';
import { GroupWrap } from 'components/group-wrap/group-wrap';
import { Lazy } from 'components/lazy/lazy';
import { LOGO_HP_1, LOGO_HP_2, LOGO_HP_3 } from 'assets/images/images';
import { colors } from 'src/styles/colors';
import { MainContent } from 'src/pages-all/master-page/components/main-content';
import {
  SubSectionHeadline,
  SubSectionHeadlineWrapper,
} from 'src/pages-all/home/components/parts/default.parts';
import { MainLayout } from 'src/pages-all/master-page/components/main-layout';
import { bodyFontSize } from 'src/pages-all/home/home.page.const';
import { shadows } from 'src/styles/theme';

const SectionContainer = styled(MainLayout)<any>`
  padding: 0 24px 40px 24px;
  background-color: ${colors.lightblueGray};
  background-image: ${({ maxTablet }) => (maxTablet ? '' : "url('images/Faces_Background.png')")};
  background-size: auto 80%;
  background-repeat: no-repeat;
  background-position: right;
  display: grid;
  place-items: center;
`;

const Wrapper = styled.div<any>`
  display: ${({ maxTablet }) => (maxTablet ? 'block' : 'grid;')};
  grid-template-columns: 1fr 1fr;
  place-items: center;
  overflow: visible;
`;

const VideoWrapper = styled.div<any>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ tablet }) => (tablet ? '' : '50px 0 25px 0')};
`;

const DescriptionBox = styled.div`
  margin: 2rem 0;
`;

export const CardWrapper = styled(Card)<{ mobile: boolean }>`
  width: 130px;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-box-shadow: ${({ mobile }) => (mobile ? 'none' : shadows.shadow1)};
  box-shadow: ${({ mobile }) => (mobile ? 'none' : shadows.shadow1)};
`;

export const Row = styled(GroupWrap)<{ mobile: boolean }>`
  margin: 1rem 0 0 0;
  display: grid;
  column-gap: 1rem;
  grid-template-columns: 1fr 1fr 1fr;
  justify-items: start;

  .group-wrap-item {
    flex: 1;
    display: flex;
    width: 100%;

    .ant-card {
      width: 100%;

      .ant-card-body {
        padding: ${({ mobile }) => (mobile ? '0.5rem' : '0.5rem')};
      }
    }
  }
`;

export const ImageWrapper = styled.div<any>`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: ${({ minHdDesktop }) => (minHdDesktop ? '160px' : '60px')};
`;

export const VideoSection: FC = () => {
  const { video } = useContext(CmsContext);
  const {
    maxTablet,
    maxMobileLarge,
    minHdDesktop,
    minTablet,
    minDesktop,
    maxDesktop,
  } = useBreakpoints();
  const imageHeight = minHdDesktop ? '60px' : minTablet ? '50px' : '30px';

  if (maxTablet)
    return (
      <SectionContainer maxTablet={maxTablet} id="video-section">
        <Wrapper maxTablet={maxTablet}>
          <SubSectionHeadline headline={translate(translationKeys.homepage.video.title)} />
          <VideoWrapper maxTablet={maxTablet}>
            <VideoPlayer id={video?.videoID} ratio={video?.videoRatio} />
          </VideoWrapper>
          <SubSectionHeadlineWrapper
            tablet={minTablet}
            mobile={maxMobileLarge}
            desktop={minDesktop}
            style={{ textAlign: maxMobileLarge ? 'center' : 'left', marginTop: '20px' }}
          >
            <Text size={14} fontWeight={600} color={'blueGray'}>
              {translate(translationKeys.homepage.video.description)}
            </Text>
            <Text
              size={bodyFontSize(maxMobileLarge)}
              color={'blueGray'}
              style={{ display: 'block', fontStyle: 'italic' }}
            >
              {translate(translationKeys.homepage.video.descriptionExtra)}
            </Text>
          </SubSectionHeadlineWrapper>
        </Wrapper>
      </SectionContainer>
    );

  return (
    <SectionContainer maxTablet={maxTablet} id="video-section">
      <MainContent>
        <Wrapper maxTablet={maxTablet}>
          <SubSectionHeadline
            headline={translate(translationKeys.homepage.video.title)}
          >
            <DescriptionBox>
              <Text
                size={bodyFontSize(maxMobileLarge)}
                fontWeight={600}
                color={'blueGray'}
                style={{ display: 'block' }}
              >
                {translate(translationKeys.homepage.video.description)}
              </Text>
              <Text
                size={bodyFontSize(maxMobileLarge)}
                color={'blueGray'}
                style={{ display: 'block', fontStyle: 'italic' }}
              >
                {translate(translationKeys.homepage.video.descriptionExtra)}
              </Text>
            </DescriptionBox>
          </SubSectionHeadline>
          <VideoWrapper tablet={minTablet}>
            <VideoPlayer
              id={video?.videoID}
              ratio={video?.videoRatio}
              width={maxDesktop ? 350 : 500}
              style={{ boxShadow: '0px 2px 15px 2px rgba(0,0,0,0.25)' }}
            />
          </VideoWrapper>
        </Wrapper>
      </MainContent>
    </SectionContainer>
  );
};
